import { getLeaveAReviewWidgetData, getDemoData, getPreviewData } from './api';
import type { InitializedWidgetData, WidgetData, PreviewConfig } from './types';

export function parseQueryParams(searchParams?: string) {
  const urlParams = new URLSearchParams(searchParams || window.location.search);
  const reminder = urlParams.get('r');
  const ratingClicked = urlParams.get('rating')
    ? parseInt(urlParams.get('rating')!)
    : null;

  let mode: 'demo' | 'preview' | 'live' = 'live';
  if (reminder === 'demo') {
    mode = 'demo';
  } else if (
    reminder &&
    (urlParams.get('business_name') ||
      urlParams.get('theme') ||
      urlParams.get('happy_message') ||
      urlParams.get('unhappy_message') ||
      urlParams.get('unhappy_form_only') ||
      urlParams.get('enabled_providers') ||
      urlParams.get('stars_cutoff') ||
      urlParams.get('rating_enabled') ||
      urlParams.get('google_url') ||
      urlParams.get('yelp_url') ||
      urlParams.get('facebook_url') ||
      urlParams.get('tripadvisor_url'))
  ) {
    mode = 'preview';
  }

  const previewConfig: PreviewConfig = {};
  if (mode === 'preview') {
    if (urlParams.get('business_name'))
      previewConfig.business_name = urlParams.get('business_name')!;
    if (urlParams.get('theme')) previewConfig.theme = urlParams.get('theme')!;
    if (urlParams.get('happy_message'))
      previewConfig.happy_message = urlParams.get('happy_message')!;
    if (urlParams.get('unhappy_message'))
      previewConfig.unhappy_message = urlParams.get('unhappy_message')!;
    if (urlParams.get('unhappy_contact'))
      previewConfig.unhappy_contact = urlParams.get('unhappy_contact')!;
    if (urlParams.get('unhappy_form_only'))
      previewConfig.unhappy_form_only =
        urlParams.get('unhappy_form_only') === 'true';
    if (urlParams.get('enabled_providers'))
      previewConfig.enabled_providers = urlParams.get('enabled_providers')!;
    if (urlParams.get('stars_cutoff'))
      previewConfig.stars_cutoff = parseInt(urlParams.get('stars_cutoff')!);
    if (urlParams.get('rating_enabled'))
      previewConfig.rating_enabled = urlParams.get('rating_enabled') === 'true';
    if (urlParams.get('site'))
      previewConfig.site = parseInt(urlParams.get('site')!);
    if (urlParams.get('google_url'))
      previewConfig.google_url = urlParams.get('google_url')!;
    if (urlParams.get('yelp_url'))
      previewConfig.yelp_url = urlParams.get('yelp_url')!;
    if (urlParams.get('facebook_url'))
      previewConfig.facebook_url = urlParams.get('facebook_url')!;
    if (urlParams.get('tripadvisor_url'))
      previewConfig.tripadvisor_url = urlParams.get('tripadvisor_url')!;
  }

  return { reminder, ratingClicked, mode, previewConfig };
}

export async function initializeWidgetData(
  reminder: string | null,
  ratingClicked: number | null,
  mode: 'demo' | 'preview' | 'live',
  previewConfig: PreviewConfig
): Promise<InitializedWidgetData> {
  if (mode === 'demo') {
    const demoData = await getDemoData();
    return { ...demoData, ratingClicked, mode };
  }

  if (mode === 'preview') {
    const previewData = getPreviewData(previewConfig);
    return { ...previewData, ratingClicked, mode };
  }

  if (!reminder || reminder === 'demo') {
    throw new Error('No reminder parameter provided for live mode');
  }

  const response = await getLeaveAReviewWidgetData(reminder);
  const result: WidgetData = await response.json();
  return { ...result, ratingClicked, mode };
}
